(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["/Users/sy/Desktop/ys-app/app/drsp/drsp-web-app"] = factory();
	else
		root["/Users/sy/Desktop/ys-app/app/drsp/drsp-web-app"] = factory();
})(self, function() {
return 